var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('photo-stream-component',{attrs:{"sections":_vm.sections}})}
var staticRenderFns = []

export { render, staticRenderFns }